import { useCallback, useEffect, useState } from 'react';
import { fetchFleetOverview } from '../api/equipment';
import { headerStatsFromOverview } from '../lib/fleetHeaderStats';

/** Последний удачный снимок — Header на каждой странице свой, без кэша снова 0/0. */
let cachedStats = null;
/** Один запрос на все одновременные монтирования шапки. */
let inflight = null;

async function loadOverview() {
  if (!inflight) {
    inflight = fetchFleetOverview().finally(() => {
      inflight = null;
    });
  }
  return inflight;
}

/**
 * Счётчики Оборудования для шапки: тот же fleet overview, раз в 60 с + visibilitychange.
 */
export function useFleetHeaderStats(enabled = true) {
  const [stats, setStats] = useState(() => cachedStats ?? headerStatsFromOverview(null));
  const [ready, setReady] = useState(() => cachedStats != null);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    try {
      const overview = await loadOverview();
      const next = headerStatsFromOverview(overview);
      cachedStats = next;
      setStats(next);
      setReady(true);
    } catch {
      // шапку не ломаем при сбое опроса — оставляем кэш
    }
  }, [enabled]);

  useEffect(() => {
    refresh();
    if (!enabled) return undefined;
    const timer = setInterval(refresh, 60_000);
    const onVisible = () => {
      if (document.visibilityState === 'visible') refresh();
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [enabled, refresh]);

  return { stats, ready, refresh };
}
